import type { Config } from 'app/config';
import { createMirrorLookups } from 'app/utils/hyrox-mirror/lookups';
import { type MirrorSession, createMirrorSession, resolveMirrorConfig } from 'app/utils/hyrox-mirror/session';
import type { MirrorLookups } from 'app/utils/hyrox-mirror/translate';
import { peekAuthorization } from 'state/auth';

export interface HyroxMirror {
  graphqlUrl: string;
  lookups: MirrorLookups;
  session: MirrorSession;
}

export const createHyroxMirror = (config: Config): HyroxMirror | null => {
  const mirrorConfig = resolveMirrorConfig(config);

  if (mirrorConfig === null) {
    return null;
  }

  const session = createMirrorSession(mirrorConfig);
  const graphqlUrl = `${mirrorConfig.baseUrl}/graphql`;
  const lookups = createMirrorLookups({
    getHyroxAccessToken: session.getAccessToken,
    refreshHyroxAccessToken: session.refreshAccessToken,
    // peek, not getPersistedState: that one wipes localStorage when the session is expired
    getOneFiitAuthorization: peekAuthorization,
    hyroxGraphqlUrl: graphqlUrl,
    oneFiitGraphqlUrl: config.REACT_APP_HYROX_API_URL,
  });

  return { graphqlUrl, lookups, session };
};
